import productMutations from '@/store/modules/products.mutations'
import productActions from '@/store/modules/products.actions'
import productGetters from '@/store/modules/products.getters'
import widgetOptions from '@/helpers/widget-options'

export default {
  namespaced: true,

  state: {
    canBeOrdered: false,
    categories: [],
    all: [],
    view: widgetOptions.style.grid_view ? 'grid' : 'list',
    category: 'all',
    search: '',
    loading: true,
    loaded: false,
    error: null,
    sort: {
      field: 'name',
      dir: 1 // 1 for asc -1 for desc
    },
    filters: {
      priceRange: [],
      strain: [],
      brand: []
    },
    priceRange: []
  },

  mutations: productMutations,
  actions: productActions,
  getters: productGetters
}
